import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { TimeoutDialogData } from './timeout-dialog.data';

@Component({
    selector : 'timeout-dialog',
    template: require('./timeout-dialog.component.html'),
    styles: [require('./timeout-dialog.component.scss')]
})
export class TimeoutDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: TimeoutDialogData) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/timeout-dialog/timeout-dialog.component.ts